import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";
import { EntBasicHB } from "../handBooks/basicHB";
import { EntTypeProduct } from "../handBooks/typeProduct";
import { EntDirectoryInfoName } from "../directoryInfoName";
import { EntUnitMeasurement } from "../handBooks/unitMeasurement";

export class EntOrganicproducers {
  id: number|null = null;
  name: string|null = null;
  legalFormId: number|null = null;
  regionId: number|null = null;
  areaId: number|null = null;
  territorialUnitId: number|null = null;
  registrationDate: string|null = null;
  certificationBody: string|null = null;
  certificationNumber: string|null = null;
  validUntil: string|null = null;
  latitude: number|undefined = undefined;
  longitude: number|undefined = undefined;
  statusId: number|null = null;
  
  livestockProductions: EntLivestockProduction[] = [];
  files?: EntFiles[];
  deleteFileIds?: number[];

  region?: EntTerritorialsUnits;
  area?: EntTerritorialsUnits;
  territorialUnit?: EntTerritorialsUnits;
  legalForm?: EntDirectoryInfoName;
  status?: EntBasicHB;
}

export class EntLivestockProduction {
  id: number|null = null;
  producerId: number|null = null;
  year: number|null = null;
  animalTypeId: number|null = null;
  productTypeId: number|null = null;
  quantity: number|null = null;
  unitMeasurementId: number|null = null;
  productionMethodId: number|null = null;

  animalType?: EntBasicHB;
  productType?: EntTypeProduct;
  unitMeasurement?: EntUnitMeasurement;
  productionMethod?: EntBasicHB;
}

export class EntFiles {
  id: number|null = null;
  name: string|null = null;
  path: string|null = null;
  pathCropped: string|null = null;
  extension: string|null = null;
  type: string|null = null;
  createdTime: string|null = null;
}